import { createContext, useContext, type ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

import { useThemeMode } from '@/hooks/useThemeMode';
import { getTheme } from './index';

interface ThemeContextType {
  mode: 'light' | 'dark';
  toggleMode: () => void;
  setLightMode: () => void;
  setDarkMode: () => void;
  isDark: boolean;
  isLight: boolean;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const themeMode = useThemeMode();
  const theme = getTheme(themeMode.mode);

  return (
    <ThemeContext.Provider value={themeMode}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeToggle = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useThemeToggle debe usarse dentro de un ThemeProvider');
  }
  return context;
};